$('.datepicker').pickadate({
    monthsFull: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
    monthsShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    weekdaysFull: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
    weekdaysShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
    showMonthsShort: undefined,
    showWeekdaysFull: undefined,
    min: 0,

    // Buttons
    today: 'Dnes',
    clear: 'Vyčistit',
    close: 'Zavřít',

    // Accessibility labels
    labelMonthNext: 'Následující měsíc',
    labelMonthPrev: 'Předchozí měsíc',
    labelMonthSelect: 'Vyberte měsíc',
    labelYearSelect: 'Vyberte rok',

    // Formats
    format: 'dd. mm. yyyy',
    firstDay: 1,

    onSet: function(context) {
        console.log('Just set stuff:', context);

        let el = document.getElementsByClassName('datepicker');
        Nette.validateControl(el);
        // #frm-inquiryForm-date
    }
});

$('.timepicker').pickatime({
    format: 'HH:i',
    formatLabel: 'H:i',
    formatSubmit: 'HH:i',

    // Buttons
    clear: 'Vyčistit',

    onSet: function(context) {
        console.log('Just set stuff:', context);

        let el = document.getElementsByClassName('timepicker');
        Nette.validateControl(el);
        // #frm-inquiryForm-date
    }
});